import { later } from '@ember/runloop';

import $ from 'jquery';

import { Direction } from 'webapp/enums/enums';
import { TourDoneKey, TourId } from 'webapp/enums/tour';
import { TrackingEvent } from 'webapp/enums/tracking';

import type { StepData } from 'webapp/models-custom/tour';
import TourBase from 'webapp/models-custom/tour';
import { HiddenTourStep } from 'webapp/models-custom/tour/designer/option-hidden';

export default class DesignerDragAndDropTour extends TourBase {
	static keyForPersistantDone = TourDoneKey.DESIGNER__DRAG_N_DROP;
	override trackEvent: TrackingEvent | '' = TrackingEvent.BUBBLES_DESIGNER_DRAG_AND_DROP;

	get id(): string {
		return TourId.DESIGNER__DRAG_N_DROP;
	}

	override get keyForPersistantDone(): string {
		return DesignerDragAndDropTour.keyForPersistantDone;
	}

	override get stepData(): StepData[] {
		return [
			{
				direction: Direction.RIGHT,
				allowStacked: true,
				attachTo: () => {
					return $('.designer-panel--left .metric-list li').eq(0);
				},
			},
		];
	}

	override start(): void {
		// delay because we wait for panel to open (300ms)
		later(() => {
			super.start();
			this.markDone(); // just one step, once seen, it's done
		}, 500);
	}

	override end(): void {
		super.end();
		this.flowTourDesignerService.resetHiddenTourExplicitlyClosedStatus(
			HiddenTourStep.LEFT_PANEL_HIDDEN,
		);
	}
}
